Object.defineProperty(exports, "__esModule", { value: true });
var MapIndexed = /** @class */ (function () {
    function MapIndexed() {
    }
    /**
     * Transforms each element into another value by applying the given `transform` function and returns a new sequence.
     *
     * @param {(index: number, value: T) => R} transform
     * @returns {Sequence<R>}
     */
    MapIndexed.prototype.mapIndexed = function (transform) {
        return this.withIndex()
            .map(function (it) { return transform(it.index, it.value); });
    };
    return MapIndexed;
}());
exports.MapIndexed = MapIndexed;
//# sourceMappingURL=mapIndexed.js.map